/**
 * Client-app klacht types — mirror van KledaClientAppRest.KlachtSummaryDto
 * (Fase 1a) + label-helpers voor de UI (Fase 2).
 */

export type KlachtStatus =
  | 'Geregistreerd'
  | 'In_Behandeling'
  | 'Wacht_op_Klant'
  | 'Opgelost'
  | 'Gesloten'

export interface KlachtUpdate {
  datum: string         // ISO datetime
  type: string          // 'StatusChange' | 'Comment' | 'ActionAdded' | 'ActionResolved'
  tekst: string
}

export interface KlachtVervolgWo {
  werkOrderId: string
  werkOrderNummer: string
  status: string
}

export interface ClientKlacht {
  klachtId: string
  klachtNummer: string
  status: KlachtStatus
  type: string
  datumGeopend: string  // ISO
  beschrijving?: string
  laatsteUpdates?: KlachtUpdate[]
  vervolgWerkOrders?: KlachtVervolgWo[]
}

/**
 * Klantvriendelijke labels per status — gebruikt door KlachtBanner en KlachtView.
 * Houdt de Kleda-toon: warm, vakkundig, empathisch. Geen jargon.
 *
 * NB: client-app gebruikt formele "uw"-vorm (functionele communicatie),
 * verschillend van field-app die "jij/je" gebruikt voor de chauffeur.
 */
export const KLACHT_STATUS_LABELS: Record<KlachtStatus, string> = {
  Geregistreerd: 'We hebben uw klacht ontvangen',
  In_Behandeling: 'We zijn met uw klacht bezig',
  Wacht_op_Klant: 'We wachten op uw reactie',
  Opgelost: 'Uw klacht is opgelost',
  Gesloten: 'Klacht afgesloten',
}

export const KLACHT_TYPE_LABELS: Record<string, string> = {
  Reiniging_Niet_OK: 'Reiniging niet OK',
  Schade_Cinco: 'Schade tijdens behandeling',
  Verkeerd_Item: 'Verkeerd kleed of item',
  Pricing: 'Prijs',
  Communicatie: 'Communicatie',
  Levertijd: 'Levertijd',
  Anders: 'Anders',
}

export function klachtTypeLabel(type: string | undefined): string {
  if (!type) return 'Klacht'
  return KLACHT_TYPE_LABELS[type] || type.replace(/_/g, ' ')
}

/**
 * Open klachten = banner zichtbaar. 'Gesloten' verbergt de banner.
 * 'Opgelost' blijft zichtbaar (groen) zodat klant ziet dat het rond is.
 */
export function isKlachtOpen(status: KlachtStatus): boolean {
  return status !== 'Gesloten'
}
